import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const APP_RENAME = gql(`
  mutation appRename($organizationSlug: String!, $appID: ID!, $appName: String!) {
    appRename(organizationSlug: $organizationSlug, appData:  {
       appID: $appID,
       appName: $appName
    }) {
      __typename
      id
      displayName
    }
  }
`);

export function useAppRename() {
  return useMutation(APP_RENAME);
}
